<template>
  <div class="about-container section-container">
    <div class="about-message section-message">
      <h2>About Us</h2>
      <p>
        We're Donut World, established in 1983, also known as the "Little Red
        Barn in Gresham." Donut World is a locally owned bakery shop, dedicated
        to serving classic donuts made fresh throughout the day. We also serve a
        variety of beverages; including coffee, espresso drinks, soft drinks,
        juices, milk and smoothies.
      </p>
      <p>
        There's nothing fancy about us, we just believe in serving our customers
        high-quality, freshly baked donuts at a reasonable price.
      </p>
    </div>

    <div class="about-image-wrapper section-image">
      <div class="about-image image-wrapper dp-9">
        <div class="image-bg"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "About",
  mounted() {}
};
</script>

<style lang="scss">
.about-image .image-bg {
  background-image: url("~@/assets/images/barn.jpg");
}
</style>
